const userInfo = {
  namespaced: true,
  state: {
    userInfo: {
      name: '初始数据'
    }
  },
  mutations: {
    setUserInfo(state, data = {}) {
      state.userInfo = data
    }
  },
  actions: {
    setUserInfo({ dispatch, commit, state, getters }, data) {
      const user = {
        name: '测试数据',
        age: 18
      }
      Object.assign(user, data)
      commit('setUserInfo', user)
    }
  },
  getters: {
    userInfo: (state, getters) => state.userInfo
  }
}

export default userInfo



// WEBPACK FOOTER //
// ./src/store/modules/user.js